var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" Go to "),_c('a',{attrs:{"href":"https://support.blits.ai/portal/en/kb/knowledgebase"}},[_vm._v(" https://support.blits.ai/portal/en/kb/knowledgebase ")])])
}]

export { render, staticRenderFns }